export let SIZES = /*#__PURE__*/function (SIZES) {
  SIZES["SMALL"] = "small";
  SIZES["NORMAL"] = "normal";
  SIZES["LARGE"] = "large";
  return SIZES;
}({});
export let TYPES = /*#__PURE__*/function (TYPES) {
  TYPES["PRIMARY"] = "primary";
  TYPES["SECONDARY"] = "secondary";
  return TYPES;
}({});